export const MASTERS_ACTIONS = {
    MASTERS_SEARCH: 'MASTERS_SEARCH',
    MASTERS_SEARCH_SUCCESS: 'MASTERS_SEARCH_SUCCESS',
    MASTERS_SEARCH_ERROR: 'MASTERS_SEARCH_ERROR',

    MASTERS_UPSERT: 'MASTERS_UPSERT',
    MASTERS_UPSERT_SUCCESS: 'MASTERS_UPSERT_SUCCESS',
    MASTERS_UPSERT_ERROR: 'MASTERS_UPSERT_ERROR',

    MASTERS_EDIT: 'MASTERS_EDIT',

    MASTERS_RESET: 'MASTERS_RESET',
};

export const mastersResetAction = () => ({
    type: MASTERS_ACTIONS.MASTERS_RESET,
});

export const mastersSearchAction = (payload) => ({
    type: MASTERS_ACTIONS.MASTERS_SEARCH,
    ...payload,
});

export const mastersEditAction = (payload) => ({
    type: MASTERS_ACTIONS.MASTERS_EDIT,
    ...payload,
});

export const mastersUpsertAction = (payload) => ({
    type: MASTERS_ACTIONS.MASTERS_UPSERT,
    ...payload,
});

export default {
    MASTERS_ACTIONS,
    mastersSearchAction,
    mastersUpsertAction,
    mastersEditAction,
};
